import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full px-5 py-16 sm:py-24 border-y" style={{
    backgroundColor: '#0A2010',
    borderColor: 'rgba(0,200,83,0.25)'
  }} data-id="element-152">
      <div className="mx-auto max-w-2xl text-center" data-id="element-153">
        <Reveal data-id="element-154">
          <div className="flex justify-center" data-id="element-155">
            <div className="flex h-20 w-20 items-center justify-center rounded-full" style={{
            backgroundColor: 'rgba(0,200,83,0.15)'
          }} data-id="element-156">
              <ShieldCheckIcon className="w-10 h-10" style={{
              color: '#00C853'
            }} aria-hidden="true" data-id="element-157" />
            </div>
          </div>

          <h2 className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-extrabold" style={{
          color: '#00C853'
        }} data-id="element-158">
            GARANTÍA — 7 DÍAS
          </h2>

          <p className="mt-5 text-base sm:text-lg text-white/85" data-id="element-159">
            Abrís todo. Lo revisás. Lo aplicás.
            <br data-id="element-160" />
            Si en 7 días no es lo que esperabas:
          </p>

          <p className="mt-4 text-2xl sm:text-3xl font-bold text-white" data-id="element-161">
            Te devolvemos el 100%.
          </p>

          <p className="mt-5 text-sm text-white/55" data-id="element-162">
            Sin preguntas. Sin formularios. Sin drama.
            <br data-id="element-163" />
            Más de 500 jóvenes lo tienen. Tasa de devoluciones: menor al 1%.
          </p>
        </Reveal>
      </div>
    </section>;
}